import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5.2rem;
  width: 100%;
  padding: 1.4rem;
  box-shadow: 0rem 0.1rem 0.15rem 0rem rgba(0, 0, 0, 0.15);
`;
export const Container = styled.div`
  display: flex;
  align-items: center;
`;
export const Name = styled.div`
  font-family: Pretendard;
  font-size: 1.9rem;
  font-weight: 500;
  margin-left: 1.2rem;
`;
